// 商品ページ下部ストーリーの「2本・4本・8本」ボタン。
// 押すと商品フォームのセット選択を切り替え、フォームまで戻す。
// JavaScriptが動かない環境や選択肢が見つからないときは、リンク先(バリアントのURL)へそのまま移動する。
if (!customElements.get('ny-set-jump')) {
  customElements.define(
    'ny-set-jump',
    class NySetJump extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const link = event.target.closest('a[data-option-value]');
        if (!link) return;

        const picker = document.querySelector('variant-selects');
        if (!picker) return;

        const input = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
          (radio) => radio.value === link.dataset.optionValue
        );
        if (!input) return;

        event.preventDefault();
        if (!input.checked) input.click();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        picker.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }
    }
  );
}
